export const betHistorycolumns = [
  { field: "resTimeStamp", header: "Time Id", width: "3.5%" },
  { field: "userId", header: "Customer Id", width: "1%" },
  { field: "transactionId", header: "Transaction Id", width: "1%" },
  { field: "raceKey", header: "Race Key", width: "3%" },
  { field: "poolType", header: "Pool", width: "1%" },
  { field: "eventType", header: "Type", width: "1%" },
  { field: "provider", header: "Provider", width: "1.2%" },
  { field: "isResulted", header: "Resulted", width: "1.2%" },
  { field: "betStatus", header: "Bet Status", width: "1.2%" },
  { field: "refundAmt", header: "Refund", width: "0.9%" },
  { field: "pnl", header: "PNL", width: "1%" },
  { field: "totalWinnings", header: "Return", width: "0.9%" },
  { field: "successBetAmt", header: "Invested", width: "1%" },
];
export const wagersCSV_Headers = [
  { label: "Time ID", key: "resTimeStamp" },
  { label: "Customer ID", key: "userId" },
  { label: "TRANSACTION ID", key: "transactionId" },
  { label: "RACE KEY", key: "raceKey" },
  { label: "POOL", key: "poolType" },
  { label: "TYPE", key: "eventType" },
  { label: "PROVIDER", key: "provider" },
  { label: "RESULTED", key: "isResulted" },
  { label: "BET STATUS", key: "betStatus" },
  { label: "REFUND", key: "refundAmt" },
  { label: "PNL", key: "pnl" },
  { label: "RETURN", key: "totalWinnings" },
  { label: "INVESTED", key: "successBetAmt" },
  { label: "SELECTION", key: "selection" },
  { label: "SELECTION ODDS", key: "selectionOdds" },
  { label: "PAYOUT SELECTION", key: "payoutSelection" },
  { label: "PAYOUT SELECTION ODDS", key: "payoutOdds" },
];
export const clientColumns = [
  { field: "resTimeStamp", header: "Time Id", width: "1.5%" },
  { field: "transactionId", header: "Transaction Id", width: "1%" },
  { field: "raceKey", header: "Race Key", width: "2.5%" },
  { field: "poolType", header: "Pool", width: "1%" },
  { field: "eventType", header: "Type", width: "1%" },
  { field: "provider", header: "Provider", width: "1.2%" },
  { field: "isResulted", header: "Resulted", width: "1%" },
  { field: "betStatus", header: "Bet Status", width: "1.2%" },
  { field: "pnl", header: "PNL", width: "1%" },
  { field: "successBetAmt", header: "Invested", width: "1%" },
  { field: "refundAmt", header: "Refund", width: "0.9%" },
  { field: "totalWinnings", header: "Return", width: "0.9%" },
];
export const investDataColumns = [
  { field: "selection", header: "Selection", width: "2%" },
  { field: "amount", header: "Amount", width: "2%" },
  { field: "ticket", header: "Ticket", width: "3%" },
];
export const payoutColumns = [
  { field: "selection", header: "Selection", width: "2%" },
  { field: "odds", header: "Odds", width: "2%" },
];
export const walletDataList = [
  { label: "AUD", value: "AUD" },
  { label: "USD", value: "USD" },
  { label: "GPB", value: "GPB" },
  { label: "EUR", value: "EUR" },
  { label: "HKD", value: "HKD" },
];
export const raceList = [
  { field: "timeId", header: "Time Id" },
  { field: "action", header: "Action" },
  { field: "localDate", header: "Local Date" },
  { field: "TrackCode", header: "Track Code" },
  { field: "RaceNo", header: "Race No" },
];
export const raceTripList = [
  { field: "timeId", header: "Time Id" },
  { field: "action", header: "Action" },
  { field: "localDate", header: "Local Date" },
  { field: "TrackCode", header: "Track Code" },
  { field: "RaceNo", header: "Race No" },
  { field: "selId", header: "Sel Id" },
  { field: "Scratched", header: "Scratched" },
];
export const poolList = [
  { field: "timeId", header: "Time Id" },
  { field: "action", header: "Action" },
  { field: "localDate", header: "Local Date" },
  { field: "TrackCode", header: "Track Code" },
  { field: "RaceNo", header: "Race No" },
  { field: "poolType", header: "Pool Type" },
  { field: "provider", header: "Provider" },
];
export const toteSummaryDataList = [
  { field: "localDate", header: "Local Date" },
  { field: "pzoneCode", header: "Track Code" },
  { field: "raceNo", header: "Race No" },
  { field: "poolType", header: "Pool Type" },
  { field: "poolTotal", header: "Pool Total" },
  { field: "layoffTotal", header: "Layoff Total" },
  { field: "totalPayoff", header: "Total Payoff" },
];
